import { render, staticRenderFns } from "./Quartier.vue?vue&type=template&id=455b5dba&scoped=true"
import script from "./Quartier.vue?vue&type=script&lang=js"
export * from "./Quartier.vue?vue&type=script&lang=js"
import style0 from "./Quartier.vue?vue&type=style&index=0&id=455b5dba&prod&scoped=true&lang=scss"
import style1 from "./Quartier.vue?vue&type=style&index=1&id=455b5dba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b5dba",
  null
  
)

export default component.exports